export default function Is({ _, children }: { _: boolean; children: any }) {
	return _ ? <>{children}</> : null;
}
